export enum ECampaignStatus {
  Draft = 'DRAFT',
  PendingDocusign = 'PENDING_DOCUSIGN', // We no longer require DocuSign 06/21/2022, the PENDING_DOCUSIGN state isn't used anymore
  PendingData = 'PENDING_DATA',
  PendingBilling = 'PENDING_BILLING',
  Active = 'ACTIVE',
  Paused = 'PAUSED',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
}

export enum ECampaignStatusChangeReason {
  PausedManually = 'PAUSED_MANUALLY',
  PausedPaymentFailed = 'PAUSED_PAYMENT_FAILED',
}

export enum ECampaignDeliveryAddressTarget {
  MailingAddress = 'MAILING_ADDRESS',
  SiteAddress = 'SITE_ADDRESS',
}

export const HIGH_PROPENSITY_TO_SELL_PROPERTY_FILTER_PRESET = 'high-propensity-to-sell';

export const NOD_CAMPAIGN_ENABLED_USER_IDS = [
  '668db58a1a287d5bfc2ea743', // Claudia Torrijos
];
